<template>
  <!-- 用户须知 -->
  <div class="msginfo-box">
    <div class="item">
      <div class="head" id="supply" @click="showDetail">
        {{textData.title}}
        <img v-if="detailControl" src="../../assets/img/detail/arrow-up.svg" alt="">
        <img v-if="!detailControl" src="../../assets/img/detail/arrow-down.svg" alt="">
      </div>
      <ul id="supply-detail" v-if="detailControl">
        <li>
          <dl>
            <dt>{{textData.shipping_policy}}</dt>
            <dd>
              {{textData.shipping_policy_des}}
              <router-link class="dt-link " :to="{path: '/shipping',
              query: {id: $route.query.id, path: $route.query.path}}">{{textData.detail}}</router-link>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{textData.faq}}</dt>
            <dd>
              {{textData.faq_des}}
              <router-link class="dt-link " :to="{path: '/faq',
              query: {id: $route.query.id, path: $route.query.path}}">{{textData.detail}}</router-link>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{textData.refund_policy}}</dt>
            <dd>
              {{textData.refund_policy_des}}
              <span v-if="cConf.jpSupply">
               <a :href="'mailto:' + mail" class="dt-link">{{mail}}</a>
                にて弊社スタッフまで返品の着金状況をお問い合わせくださいませ。
              </span>
              <router-link class="dt-link " :to="{path: '/return',
              query: {id: $route.query.id, path: $route.query.path}}">{{textData.detail}}</router-link>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{textData.service_policy}}</dt>
            <dd>
              {{textData.service_policy_des}}
              <router-link class="dt-link " :to="{path: '/privacy',
              query: {id: $route.query.id, path: $route.query.path}}">{{textData.detail}}</router-link>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{textData.contact_us}}</dt>
            <dd>
              {{textData.contact_us_des}}
              <br>
              <!--  电话地址取json，email后端配置  -->
              <div v-if="!cConf.jpSupply">
                <div style="margin-top: 10px;word-wrap:break-word" :style="{float: cConf.alignRight ? 'right' : 'left'}">
                  <p v-if="isYahooSource">{{textData.mall_name}}{{host}}</p>
                  <p v-if="isGoogleSource">
                    {{textData.address_k}}
                    {{textData.address_v}}
                  </p>
                  <p v-if="isGoogleSource">
                    {{textData.phone_k}}
                    {{textData.phone_v}}
                  </p>
                  <p>
                    {{textData.email_k || 'Mail：'}}
                    <a :href="'mailto:' + mail" class="dt-link">{{mail}}</a>
                  </p>
                </div>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {getSupply} from "../../api/permission";

  export default {
    props: {
      mail: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isGoogleSource: source === sourceData.googleSource,
        detailControl: source === sourceData.googleSource,
        textData: {},
        cl: sessionStorage.cl,
        isYahooSource: localStorage.source === sourceData.yahooSource,
        host: location.host.replace(/^www\./, '').replace(/.com$/, ''),
        cConf: cConf
      }
    },
    async created() {
      const res = await getSupply();
      this.textData = res.data;
    },
    methods: {
      showDetail() {
        this.detailControl = !this.detailControl;
        setTimeout(() => {
          window.scrollTo({
              top: window.scrollY + 1000,
              left: 0,
              behavior: 'smooth'
          })
        }, 100)
      }
    }
  }
</script>

<style scoped>
  .msginfo-box {
    color: #555;
    font-size: 12px;
  }

  .msginfo-box .item {
    font-size: 12px;
    line-height: 21px;
  }

  .msginfo-box .item .head {
    padding-left: 37px;
    height: 37px;
    text-align: center;
    font-weight: 600;
    background: url(../../assets/img/detail/title-bg.png) center;
    background-size: auto 100%;
    font-size: 1rem;
    line-height: 37px;
    cursor: pointer;
  }

  .msginfo-box .item .head img{
    padding: 8px;
    float: right;
    display: block;
    width: 37px;
    height: 37px;
    right: 12px;
    font-size: 0;
  }

  .msginfo-box .item dl {
    margin: 0;
  }
  .msginfo-box .item dl dt,
  .msginfo-box .item dl dd {
    display: table-cell;
    padding: 10px;
    border: 1px solid #eee;
    vertical-align: middle;
    word-break: break-word;
  }

  .msginfo-box .item dl dt {
    min-width: 70px;
    width: 15%;
    text-align: center;
    border-right: none;
    border-bottom: none;
  }

  .msginfo-box .item dl dd {
    width: 640px;
    border-bottom: none;
  }

  .msginfo-box .item dl dd img {
    max-width: 100%;
    border: 0;
    vertical-align: middle;
    width: 70px;
  }

  .dt-link {
    color: #F8770E;
    cursor: pointer;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/detail/supply.vue